import { render } from "./ScLayoutNoAuth.vue?vue&type=template&id=33fc398c"
import script from "./ScLayoutNoAuth.vue?vue&type=script&lang=js"
export * from "./ScLayoutNoAuth.vue?vue&type=script&lang=js"

import "./ScLayoutNoAuth.vue?vue&type=style&index=0&id=33fc398c&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__